<form [formGroup]="form" class="flex flex-col justify-center items-start w-full h-full">
    <label #subtitleLabel for="item" class="text-label">
      {{ configSignal().label }} <b class="text-sub-label"> {{ configSignal().subLabel }} </b>
    </label>

  <div
    #inbox
    class="w-full h-10 flex justify-center items-center px-2 py-1 rounded-sm shadow-lg border border-blue-700 bg-white"
  >
    <!-- Mostrar el valor formateado si es tipo número, de lo contrario mostrar el valor normal -->
    @if (configSignal().type === 'number') {
      <input
        id="item"
        type="text"
        [value]="formattedValue()"
        (input)="onNumberInput($event)"
        (blur)="onBlurInput()"
        class="border-none focus:outline-none focus:ring-0 rounded px-3 py-2 w-full h-8 placeholder:text-gray-500"
      />
    } @else {
      <input
        id="item"
        [type]="configSignal().type"
        formControlName="item"
        [placeholder]="configSignal().placeholder"
        (blur)="onBlurInput()"
        class="border-none focus:outline-none focus:ring-0 rounded px-3 py-2 w-full h-8 placeholder:text-gray-500"
      />
    }

  </div>
  <!-- {{ form.value | json}} -->

  @if (
    (itemControl()?.invalid && (itemControl()?.touched || itemControl()?.dirty)) ||
    offTimeOut() ||
    (itemControl()?.value === '' && itemControl()?.invalid && hasWritten())
  ) {
    <div class="text-red-500 text-[10px] mt-1">
      {{ configSignal().textError }}
    </div>
  }

</form>